var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-loan-page"},[_c('vue-headful',{attrs:{"title":_vm.fullTitle}}),_c('full-loan',{attrs:{"loan-id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }